export var MouseAction;
(function (MouseAction) {
    MouseAction["ENTER"] = "enter";
    MouseAction["LEAVE"] = "leave";
    MouseAction["CLICK"] = "click";
})(MouseAction || (MouseAction = {}));
export var ChangeSource;
(function (ChangeSource) {
    ChangeSource["AUTO"] = "auto";
    ChangeSource["CLICK"] = "click";
    ChangeSource["HOVER"] = "hover";
})(ChangeSource || (ChangeSource = {}));
export var NavSwiperTrigger;
(function (NavSwiperTrigger) {
    NavSwiperTrigger["HOVER"] = "hover";
    NavSwiperTrigger["CLICK"] = "click";
})(NavSwiperTrigger || (NavSwiperTrigger = {}));
